import Vue from 'vue'
import Router from 'vue-router'
import Default from '@/components/Default'
import Header from '@/components/Header'
import Hero from '@/components/Hero'
import Features from '@/components/Features'
import How from '@/components/How'
import Why from '@/components/Why'
import Clients from '@/components/Clients'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
import BootstrapVue from 'bootstrap-vue'
import What from '@/components/What'
import Index from '@/components/Index'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'

Vue.use(Router)
Vue.use(BootstrapVue)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/contacto',
      components: {
        default: Default,
        header: Header,
        contact: Contact,
        footer: Footer
      }
    },
    {
      path: '*',
      name: 'Hello',
      components: {
        default: Default,
        header: Header,
        hero: Hero,
        features: Features,
        how: How,
        why: Why,
        contact: Contact,
        clients: Clients,
        footer: Footer,
        what: What,
        index: Index
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js